import JtlApiClient from "./base";

export const JTLCredentialsApi = {
  // Get authorization URL for a credential
  getAuthUrl: (credentialId) => {
    return JtlApiClient.get(`/jtl/auth_url/${credentialId}`);
  },

  // Create a new JTL credential
  createCredential: (credentialData) => {
    return JtlApiClient.post("/jtl/credentials/", credentialData);
    //return {"status": "success", "credential_id": db_credential.id}
  },

  // Delete a JTL credential by ID
  deleteCredential: (credentialId) => {
    return JtlApiClient.delete(`/jtl/credentials/${credentialId}`);
  },

  // Get all JTL credentials
  getCredentials: () => {
    return JtlApiClient.get("/jtl/credentials/");
  },

  // Update a JTL credential by ID
  updateCredential: (credentialId, credentialData) => {
    return JtlApiClient.put(`/jtl/credentials/${credentialId}`, credentialData);
  },

  // Toggle active status for a credential
  toggleActiveCredential: (credentialId) => {
    return JtlApiClient.post(`/jtl/credentials/${credentialId}/toggle-active`);
  },

  // Check if a credential is valid by making a test API call
  isValidCredential: (credentialId) => {
    return JtlApiClient.get(`/jtl/credentials/${credentialId}/is_valid`);
    //  return {"credential_id": credential_id, "valid": valid}
  },

  getToken: (credentialId) => {
    return JtlApiClient.get(`/jtl/credentials/${credentialId}/get_token`);
  },
};
